import { useQuery } from "@tanstack/react-query";
import { fetchAdapterHealth } from "../../lib/api.js";

/**
 * System health view: per-exchange WS connection state + last-message age.
 * Pulls from `/v1/health/adapters` every 5s. The data-ingestion service
 * publishes the underlying state to Redis on every connect/close.
 */
export function SystemHealth() {
  const q = useQuery({
    queryKey: ["health-adapters-page"],
    queryFn: fetchAdapterHealth,
    refetchInterval: 5_000,
  });

  const adapters = Object.entries(q.data ?? {});
  return (
    <div className="flex h-full flex-col gap-4 overflow-auto bg-zinc-950 p-4">
      <section className="rounded border border-zinc-800">
        <header className="border-b border-zinc-800 px-3 py-2 text-xs uppercase tracking-wider text-zinc-400">
          Exchange WebSocket adapters
        </header>
        {adapters.length === 0 ? (
          <div className="p-4 text-xs text-zinc-500">
            Waiting for adapter health…
          </div>
        ) : (
          <table className="w-full text-xs">
            <thead className="text-zinc-500">
              <tr className="text-left">
                <th className="px-3 py-2">Exchange</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Last update</th>
                <th className="px-3 py-2">Reason</th>
              </tr>
            </thead>
            <tbody>
              {adapters.map(([name, h]) => {
                const ageMs =
                  h.ts && h.connected ? Date.now() - h.ts : null;
                return (
                  <tr
                    key={name}
                    className="border-t border-zinc-900 hover:bg-zinc-900/40"
                  >
                    <td className="px-3 py-2 font-mono text-zinc-200">{name}</td>
                    <td className="px-3 py-2">
                      <span
                        className={
                          "rounded px-1.5 py-0.5 font-mono " +
                          (h.connected
                            ? "bg-accent/10 text-accent"
                            : "bg-bear/10 text-bear")
                        }
                      >
                        {h.connected ? "UP" : "DOWN"}
                      </span>
                    </td>
                    <td className="px-3 py-2 font-mono text-zinc-400">
                      {h.ts ? new Date(h.ts).toISOString().slice(11, 19) : "—"}
                      {ageMs !== null && (
                        <span className="ml-2 text-zinc-600">
                          ({Math.floor(ageMs / 1000)}s ago)
                        </span>
                      )}
                    </td>
                    <td className="px-3 py-2 text-zinc-500">
                      {h.reason ?? "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
